import { getISOWeeksInYear } from 'date-fns'

import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

export { hasProjectErrors, validateProject }
export type { ProjectErrors }

const MAX_WEEKS_IN_YEAR = 53

type ProjectErrors = Partial<Record<keyof HoofdleidingProject, boolean>>

const gteZero = (value: number | undefined) => value !== undefined && value >= 0

const isInvalidWeek = (week: number | undefined, jaar: Date | null) => {
  if (!week) return false
  if (week > MAX_WEEKS_IN_YEAR || week < 1) return true

  // Not every year has a week 53
  return (
    !!jaar &&
    week === MAX_WEEKS_IN_YEAR &&
    getISOWeeksInYear(jaar) !== MAX_WEEKS_IN_YEAR
  )
}

const validateProject = ({
  project,
  startUitvoeringWeek,
  startUitvoeringJaar,
}: {
  project: Partial<HoofdleidingProject>
  startUitvoeringWeek: number | undefined
  startUitvoeringJaar: Date | null
}): ProjectErrors => ({
  naam: !project.naam,
  gemeente: !project.gemeente,
  gebiedscode: !project.gebiedscode,
  typeWerk: !project.typeWerk,
  statusText: !project.statusText,
  adres: !project.adres,
  doorlooptijdWeken:
    !!project.doorlooptijdWeken && project.doorlooptijdWeken < 1,
  startUitvoeringWeek: isInvalidWeek(startUitvoeringWeek, startUitvoeringJaar),
  disciplineVerzamelingen:
    !!project.gebiedscode && !project.disciplineVerzamelingen?.length,
  tracelengte: !gteZero(project.tracelengte),
  woningen: !gteZero(project.woningen),
  appartementen: !gteZero(project.appartementen),
  bedrijfsunits: !gteZero(project.bedrijfsunits),
})

const hasProjectErrors = (errors: ProjectErrors) =>
  Object.values(errors).some(Boolean)
